<div class="m-5 p-5 text-center" *ngIf="loading">
  <i class="fas fa-pulse fa-spinner fa-fw fa-5x"></i>
</div>
<div *ngIf="!loading">
  <h3 class="font-weight-light mb-3">
    Wage Bases&nbsp;
    <a class="text-primary" title="New Wage Base" style="cursor: pointer" (click)="$event.preventDefault(); $event.stopImmediatePropagation(); addNewWageBase()">
      <i class="ti-plus"></i>
    </a>
  </h3>
  <table class="table table-sm table-bordered">
    <thead>
      <tr>
        <th>Id</th>
        <th>Year</th>
        <th>Base</th>
        <th>Fee %</th>
        <th>Expense %</th>
        <th>Opener %</th>
        <th>Owner %</th>
        <th>Payroll Expense %</th>
        <th>Add to Base ?</th>
        <th>Include Base in Factor ?</th>
        <th>Effective Date</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let wageBase of wageBases">
        <td>
          <a title="View" class="text-primary" style="cursor: pointer" (click)="$event.preventDefault(); $event.stopImmediatePropagation(); showWageBase(wageBase)">{{ wageBase.id }}</a>
        </td>
        <td>{{ wageBase.year }}</td>
        <td>{{ wageBase.base | currency: 'USD':'symbol-narrow':'1.2-2' }}</td>
        <td>{{ wageBase.fee_percent / 100 | percent: '1.2-2' }}</td>
        <td>{{ wageBase.expense_percent / 100 | percent: '1.2-2' }}</td>
        <td>{{ wageBase.opener_percent / 100 | percent: '1.2-2' }}</td>
        <td>{{ wageBase.owner_percent / 100 | percent: '1.2-2' }}</td>
        <td>
          {{ wageBase.payroll_expense_percent / 100 | percent: '1.2-2' }}
          <span *ngIf="wageBase.payroll_expense_only_on_factor">&nbsp;(above base)</span>
        </td>
        <td>
          <span [ngClass]="{ 'text-success': wageBase.add_to_base, 'text-danger': !wageBase.add_to_base }">{{ wageBase.add_to_base ? 'Yes' : 'No' }}</span>
        </td>
        <td>
          <span [ngClass]="{ 'text-success': wageBase.include_base_in_factor, 'text-danger': !wageBase.include_base_in_factor }">{{ wageBase.include_base_in_factor ? 'Yes' : 'No' }}</span>
        </td>
        <td>{{ wageBase.effective_date }}</td>
        <td>
          <a title="Edit" style="cursor: pointer" class="text-primary" (click)="$event.preventDefault(); $event.stopImmediatePropagation(); editWageBase(wageBase)">
            <i class="fas fa-pencil-alt"></i>
          </a>
          <a title="Delete" style="cursor: pointer" class="text-danger" (click)="$event.preventDefault(); $event.stopImmediatePropagation(); deleteWageBase(wageBase)">
            <i class="fas fa-trash"></i>
          </a>
        </td>
      </tr>
    </tbody>
  </table>
</div>
<ng-template #wageBaseShow>
  <div class="modal-header">
    <h4 class="modal-title pull-left font-weight-light" *ngIf="selectedWageBase">Wage Base - {{ selectedWageBase.id }}</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" *ngIf="selectedWageBase">
    <table class="table table-bordered">
      <tbody>
        <tr>
          <th scope="row">Year</th>
          <td>{{ selectedWageBase.year | currency: 'USD':'symbol-narrow':'1.2-2' }}</td>
        </tr>
        <tr>
          <th scope="row">Base</th>
          <td>{{ selectedWageBase.base | currency: 'USD':'symbol-narrow':'1.2-2' }}</td>
        </tr>
        <tr>
          <th scope="row">Fee Percentage</th>
          <td>{{ selectedWageBase.fee_percent / 100 | percent: '1.2-2' }}</td>
        </tr>
        <tr>
          <th scope="row">Expense Percentage</th>
          <td>{{ selectedWageBase.expense_percent / 100 | percent: '1.2-2' }}</td>
        </tr>
        <tr>
          <th scope="row">Owner Percentage</th>
          <td>{{ selectedWageBase.owner_percent / 100 | percent: '1.2-2' }}</td>
        </tr>
        <tr>
          <th scope="row">Opener Percentage</th>
          <td>{{ selectedWageBase.opener_percent / 100 | percent: '1.2-2' }}</td>
        </tr>
        <tr>
          <th scope="row">Payroll Expense Percentage</th>
          <td>
            {{ selectedWageBase.payroll_expense_percent / 100 | percent: '1.2-2' }}
            <span *ngIf="selectedWageBase.payroll_expense_only_on_factor">&nbsp;(above base)</span>
          </td>
        </tr>
        <tr>
          <th scope="row">Add to base</th>
          <td>
            <span [ngClass]="{ 'text-success': selectedWageBase.add_to_base, 'text-danger': !selectedWageBase.add_to_base }">{{ selectedWageBase.add_to_base ? 'Yes' : 'No' }}</span>
          </td>
        </tr>
        <tr>
          <th scope="row">Include Base in Factor</th>
          <td>
            <span [ngClass]="{ 'text-success': selectedWageBase.include_base_in_factor, 'text-danger': !selectedWageBase.include_base_in_factor }">{{ selectedWageBase.include_base_in_factor ? 'Yes' : 'No' }}</span>
          </td>
        </tr>
        <tr>
          <th scope="row">Effective Date</th>
          <td>{{ selectedWageBase.effective_date }}</td>
        </tr>
        <tr>
          <th scope="row">Created</th>
          <td>
            <span *ngIf="selectedWageBase.created_by">
              {{ selectedWageBase.created_by }}
            </span>
            <br />
            @ {{ selectedWageBase.created_at }}
          </td>
        </tr>
        <tr>
          <th scope="row">Updated</th>
          <td>
            <span *ngIf="selectedWageBase.updated_by">
              {{ selectedWageBase.updated_by }}
              <br />
              @ {{ selectedWageBase.updated_at }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</ng-template>
<ng-template #wageBaseForm>
  <div class="modal-header">
    <h3 class="modal-title pull-left font-weight-light" *ngIf="selectedWageBase">
      <span *ngIf="selectedWageBase.id">Editing Wage Base - {{ selectedWageBase.id }}</span>
      <span *ngIf="!selectedWageBase.id">New Wage Base</span>
    </h3>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="form-group">
      <label>Year</label>
      <input type="number" maxlength="3" class="form-control" name="year" [(ngModel)]="selectedWageBase.year" />
    </div>
    <div class="form-group">
      <label>Base</label>
      <div class="input-group mb-3">
        <div class="input-group-prepend">
          <span class="input-group-text">$</span>
        </div>
        <input type="number" maxlength="6" class="form-control" name="base" [(ngModel)]="selectedWageBase.base" />
      </div>
    </div>
    <div class="py-1"></div>
    <legend>Percentages</legend>
    <div class="form-group">
      <label>Fee Percent</label>
      <div class="input-group mb-3">
        <input type="number" maxlength="3" class="form-control" name="fee_percent" [(ngModel)]="selectedWageBase.fee_percent" />
        <div class="input-group-append">
          <span class="input-group-text">%</span>
        </div>
      </div>
    </div>
    <div class="form-group">
      <label>Expense Percent</label>
      <div class="input-group mb-3">
        <input type="number" maxlength="3" class="form-control" name="expense_percent" [(ngModel)]="selectedWageBase.expense_percent" />
        <div class="input-group-append">
          <span class="input-group-text">%</span>
        </div>
      </div>
    </div>
    <div class="form-group">
      <label>Opener Percent</label>
      <div class="input-group mb-3">
        <input type="number" maxlength="3" class="form-control" name="opener_percent" [(ngModel)]="selectedWageBase.opener_percent" />
        <div class="input-group-append">
          <span class="input-group-text">%</span>
        </div>
      </div>
    </div>
    <div class="form-group">
      <label>Owner Percent</label>
      <div class="input-group mb-3">
        <input type="number" maxlength="3" class="form-control" name="owner_percent" [(ngModel)]="selectedWageBase.owner_percent" />
        <div class="input-group-append">
          <span class="input-group-text">%</span>
        </div>
      </div>
    </div>
    <div class="form-group">
      <label>Payroll Expense Percent</label>
      <div class="input-group mb-3">
        <input type="number" maxlength="3" class="form-control" name="payroll_expense_percent" [(ngModel)]="selectedWageBase.payroll_expense_percent" />
        <div class="input-group-append">
          <span class="input-group-text">%</span>
        </div>
      </div>
    </div>
    <div class="form-group">
      <label>Effective Date</label>
      <app-datetime-picker [showTimePicker]="false" [small]="false" [datetime]="selectedWageBase.effective_date_struct" (ngbResult)="selectedWageBase.effective_date_struct = $event"></app-datetime-picker>
    </div>
    <div class="form-group">
      <div class="custom-control custom-checkbox" (click)="selectedWageBase.payroll_expense_only_on_factor = !selectedWageBase.payroll_expense_only_on_factor">
        <input type="checkbox" class="custom-control-input" name="payroll_expense_only_on_factor" [(ngModel)]="selectedWageBase.payroll_expense_only_on_factor" />
        <label class="custom-control-label">Only on amount above base, if add percentage to base is checked</label>
      </div>
    </div>
    <div class="form-group">
      <div class="custom-control custom-checkbox" (click)="selectedWageBase.add_to_base = !selectedWageBase.add_to_base">
        <input type="checkbox" class="custom-control-input" name="add_to_base" [(ngModel)]="selectedWageBase.add_to_base" />
        <label class="custom-control-label">Add Percentage to Base amount</label>
      </div>
    </div>
    <div class="form-group">
      <div class="custom-control custom-checkbox" (click)="selectedWageBase.include_base_in_factor = !selectedWageBase.include_base_in_factor">
        <input type="checkbox" class="custom-control-input" name="include_base_in_factor" [(ngModel)]="selectedWageBase.include_base_in_factor" />
        <label class="custom-control-label">Include Base in Factor</label>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button [disabled]="saving" type="button" class="btn btn-secondary" (click)="modalRef.hide()">Cancel</button>
    <button [disabled]="saving" type="button" class="btn btn-primary" (click)="save()">
      Save
      <span *ngIf="saving">&nbsp;<i class="fas fa-spinner fa-pulse fa-fw"></i></span>
    </button>
  </div>
</ng-template>
